// Presentación compartida para "esto tiene pendientes, resaltalo" en los 3
// widgets del panel de auditoría (PanelAlertasAuditoria.tsx) — pedido
// explícito del usuario 2026-09-10: "cuando tenga cosas pendientes... haz
// que resalten de manera animada". Mismo patrón de "ping" que usa Tailwind
// para indicadores de notificación en vivo: un punto sólido ámbar con otro
// idéntico detrás que se expande y se desvanece (`animate-ping`) — la
// animación queda SOLO en ese punto, nunca en el texto/lista del widget
// (animar el contenido distraería de la lectura, no ayuda a resolver nada).
import type { JSX } from 'react';

/** Card normal vs. card "con algo por resolver" — mismo borde redondeado/padding en ambos casos, solo cambia el tinte. */
export function claseTarjetaConPendientes(hayPendientes: boolean): string {
  return hayPendientes
    ? 'rounded-lg border border-amber-400/50 bg-amber-500/5 ring-1 ring-amber-400/30 p-3 transition-colors'
    : 'rounded-lg border border-border bg-card p-3 transition-colors';
}

export function IndicadorPendiente(): JSX.Element {
  return (
    <span className="relative inline-flex size-2 shrink-0" aria-hidden="true">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75" />
      <span className="relative inline-flex size-2 rounded-full bg-amber-500" />
    </span>
  );
}
